import { APIDelete, APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

export async function GetScheduledReports(params: any, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/report/scheduled"), params, useGlobalLoader, token);
}

interface IPostScheduledReport {
    admin_id: number;
    report_id: number;
    schedule: string;
    time: string;
    day_of_week: string;
}

export async function PostScheduledReport(params: IPostScheduledReport, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/report/scheduled"), params, useGlobalLoader);
}

interface IPutScheduledReport {
    id: number;
    admin_id: number;
    report_id: number;
    schedule: string;
    day_of_week: string;
}

export async function PutScheduledReport(params: IPutScheduledReport, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/report/scheduled"), params, useGlobalLoader);
}

export async function DeleteScheduledReport(params: { id: number }, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/report/scheduled"), params, useGlobalLoader);
}